import { message } from 'antd'
import * as dateFns from 'date-fns'

export const uploadMaxSize = {
  bytes: 5242880, // 5 MB
  pretty: '5 MB',
}

export const isFileValid = (file) => {
  if (file.size > uploadMaxSize.bytes) {
    message.error(`Max file size is ${uploadMaxSize.pretty}`)
    return false
  }

  if (file.type !== 'application/pdf') {
    message.error('Invalid file type')
    return false
  }

  return true
}

export const isEndDateValid = (date) => {
  if (date && dateFns.isBefore(date, new Date())) {
    message.error(`Expiration time can not be before current date and time`)
    return false
  }

  return true
}